export default "__VITE_ASSET__DG$eclme__"